export default __webpack_public_path__ + "static/media/logo-default.16a7557c.jpg";